import { DefaultResponse, ParamsType } from "@/types/global";
import fetcher from "@/lib/fetcher";
import { buildUrlQueryParams } from "@/utils/build-url-query-params";

interface Response {
  key: string;
  value: string;
}

export const settingsService = {
  get: (key: string, params?: ParamsType) =>
    fetcher<DefaultResponse<Response>>(
      buildUrlQueryParams(`users/general-settings/${key}`, params),
    ),
};
